import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "../components/ProfilePage";

const showProfile = async () => {
  // Get the profile user from the window object
  const profileUser = window.__PROFILE;
  if (!profileUser) return;

  // Check if the current user is logged in and if it's their profile
  const currentUser = document.getElementById("account-menu")?.dataset?.name;
  if (!currentUser || profileUser !== currentUser) {
    // Not viewing own profile - don't mount React, keep server-rendered content
    return;
  }

  // Only mount React when viewing your own profile
  const reactRoot = document.getElementById("profile-react-root");
  if (!reactRoot) return;

  // Go - editable is always true here since we only mount for own profile
  const root = createRoot(reactRoot);
  root.render(React.createElement(App, { profileUser, editable: true }, null));
};

showProfile();
